import React, { useEffect } from "react";
import TitlePages from "../../../../layout/TitlePages";
import Breadcrumbs from "../../../../layout/Breadcrumbs";
import CarpetaAnio from "../../../../components/common/CarpetaAnio";

// Años de convenios disponibles (desde 2014 hasta 2026)
const ANIOS_CONVENIOS = [
  2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026,
];

const ANIO_ACTUAL = 2026;

const Convenios = () => {
  useEffect(() => {
    document.title = "Convenios";
  }, []);

  return (
    <>
      <Breadcrumbs
        path={[
          { label: "Transparencia", url: "/Transparencia" },
          { label: "Convenios" },
        ]}
      />

      <TitlePages title="Transparencia" subTitle="Convenios" />

      {/* Texto de apoyo opcional para orientar al usuario */}
      <p className="carpetas-intro-text">
        Selecciona un año para consultar los convenios
      </p>

      {/* Cuadrícula moderna responsive: 6 en escritorio, 4 en laptop, 3 en tablet, 2 en móvil */}
      <section
        className="w-100 carpetas-modernas-grid carpetas-grid margin-bottom-2"
        aria-label="Listado de Convenios por Año"
      >
        {ANIOS_CONVENIOS.map((anio, index) => (
          <CarpetaAnio
            key={anio}
            anio={anio}
            url={`/Convenios${anio}`}
            ariaLabel={`Convenios ${anio}`}
            isCurrent={anio === ANIO_ACTUAL}
            delayMs={index * 60}
          />
        ))}
      </section>
    </>
  );
};

export default Convenios;
